<page-content>
    <header-elitment header
            [hasSideMenu]="true">
    </header-elitment>

    <error-401 *ngIf="is401"></error-401>
    <error-404 *ngIf="is404"></error-404>
    <module-content *ngIf="!is401 && !is404"
                    [title]="'Teams_list' | translate"
                    [mainActions]="mainActions">
      <div class="search-bar">
        <mat-form-field
              color="primary"
              class="">
            <input matInput
                   type="text"
                   maxlength="255"
                   placeholder="{{ 'Filter' | translate }}"
                    #filterInput
                   (keyup)="onFilterKeyup(filterInput.value)">
            <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
      </div>
      <div *ngIf="dataSource.count === 0 && !isLoading" class="legend">{{ 'No_team_yet' | translate }}</div>
      <mat-table *ngIf="dataSource.count > 0 && !isLoading"
                 [dataSource]="dataSource"
                 matSort
                 [matSortStart]="'desc'"
                 (matSortChange)="onSortChange($event)">
          <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: columns"></mat-row>

          <ng-container matColumnDef="team">
              <mat-header-cell *matHeaderCellDef mat-sort-header class="name-cell">{{ 'Team_Name' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let row; let i = index" class="name-cell">
                  <div *ngIf="row.rights.view; else notLink">
                      <a (click)="onDisplayTeamClicked(row)">{{ row.team.name }}</a>
                  </div>
                  <ng-template #notLink>
                      <div>{{ row.team.name }}</div>
                  </ng-template>
              </mat-cell>
          </ng-container>

          <ng-container matColumnDef="coach">
              <mat-header-cell *matHeaderCellDef mat-sort-header class="name-cell">{{ 'Coach_Name' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let row; let i = index" class="name-cell">
                  <div>{{ row.coachNames }}</div>
              </mat-cell>
          </ng-container>

          <ng-container matColumnDef="actions">
              <mat-header-cell *matHeaderCellDef class="special-actions-cell"></mat-header-cell>
              <mat-cell *matCellDef="let row; let i = index" class="special-actions-cell">
                  <button *ngIf="row.rights.edit || row.rights.changeAthletes || row.rights.changeCoaches || row.rights.delete"
                          mat-icon-button
                          [matMenuTriggerFor]="rowMoreMenu">
                      <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #rowMoreMenu="matMenu" xPosition="before">
                      <button mat-menu-item
                              [disabled]="!row.rights.edit"
                              (click)="onModifyTeamClicked(row)">
                          <mat-icon>edit_outlined</mat-icon>&nbsp;{{ 'Edit' | translate }}
                      </button>
                      <button mat-menu-item
                              [disabled]="!row.rights.changeCoaches"
                              (click)="onManageCoachsClicked(row)">
                          <mat-icon>perm_identity</mat-icon>&nbsp;{{ 'Coachs' | translate }}
                      </button>
                      <button mat-menu-item
                              [disabled]="!row.rights.changeAthletes"
                              (click)="onManageAthletesClicked(row)">
                          <mat-icon>assignment_ind</mat-icon>&nbsp;{{ 'Athletes' | translate }}
                      </button>
                      <button mat-menu-item
                              [disabled]="!row.rights.delete"
                              (click)="onDeleteTeamClicked(row)">
                          <mat-icon>delete_outlined</mat-icon>&nbsp;{{ 'Delete' | translate }}
                      </button>
                  </mat-menu>
              </mat-cell>
          </ng-container>

      </mat-table>
      <center-loader class="paginator-data-placeholder" *ngIf="isLoading"></center-loader>
      <api-paginator *ngIf="teamsPaginator.total > 0" [paginatorFromAPi]="teamsPaginator"
                     (goToFirstPage)="pageChange(1)"
                     (goToPreviousPage)="pageChange(this.activePage -1)"
                     (goToNextPage)="pageChange(this.activePage +1)"
                     (goToLastPage)="pageChange(teamsPaginator.last_page)">
      </api-paginator>
    </module-content>
</page-content>
